import { render, staticRenderFns } from "./show.vue?vue&type=template&id=e92bd386"
import script from "./show.js?vue&type=script&lang=js&external"
export * from "./show.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports